import { IProcessedProfile } from '@/components/profileDetail';
import { transport } from '@/core';
import { post } from '@/core/api/api.service';
import { IProfile } from '@/types';
import { profileProcessor } from '../shared/profileProcessor';

export const loadProfileForPreview = (
  profileId: string,
  timestamp: string,
  token: string,
  type: string,
  brandId?: string,
): Promise<IProfile> => {
  const endpoint = '/api/app/preview';
  return post<IProfile>(endpoint, {
    id: profileId,
    timestamp,
    token,
    type,
    ...(brandId && { brandId }),
  });
};

export const resolveProfileForPreview = (
  profileId: string,
  timestamp: string,
  token: string,
  type: string,
  brandId?: string,
): Promise<IProcessedProfile> => {
  return transport
    .fetchProfileForPreview(profileId, timestamp, token, type, brandId)
    .then((res) => {
      return profileProcessor(res);
    });
};
